import { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../components/Loading";
import SingleRoom from "../components/single-room/SingleRoom";
import { useLocation } from "react-router-dom";

export default function SingleApartament() {
    const [ data, setData ] = useState(null);

    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const id = query.get("id");

    async function getRoom() {
        try {
            await axios({
                method: 'post',
                url: 'https://sunnydays-backend-c82612a62427.herokuapp.com/api/get-room',
                // url: 'http://localhost:3002/api/get-room',
                data: { id } 
            }).then(response => setData(response.data))
        } catch(error) {
            console.log(error)
        }
    };

    useEffect( () => {
        getRoom();
    }, [] );
  
    return !data ? <Loading/> : <SingleRoom data={data}/>
}